<template>
  <form id="applicator-map-filter" @submit.prevent="ApplyFilters">

    <div id="applicator-map-filter-form">

      <div id="applicator-map-filter-form-header">
        <h3>Filter Search Results</h3>
        <button id="applicator-map-filter-close-mobile" type="button" @click="$root.ToggleFiltersVisibilityOnMobile">×</button>
        <button id="applicator-map-filter-close-desktop" type="button" @click="$root.ToggleFiltersVisibilityOnDesktop">×</button>
      </div>

      <div id="applicator-map-filter-form-content">

        <div class="filter-form-field column">
          <span class="filter-form-field-label">
            <strong>International Distributors</strong>
            <small>
              <i class="fa fa-info-circle"></i> Filter by {{ $root.domainName }} distributors.
            </small>
          </span>
          <div class="filter-form-options">
            <label v-for="(category, key) in distributorOptions" class="filter-form-checkbox" :key="`distributors-${key}`">
              <input type="checkbox" v-model="appliedFilters.distributors" :value="category.id" />
              <span class="checkbox-input"></span>
              <span>{{ category.label }}</span>
            </label>
          </div>
          <span class="filter-form-field-label">
            <small>
              <a href="/find-applicator/cerakote-distributors" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i> See all of our international distributors here</a>
            </small>
          </span>
        </div>

        <div v-if="businessTypeOptions.length" class="filter-form-field column">
          <span class="filter-form-field-label">
            <strong>Business Type</strong>
            <small>
              <i class="fa fa-info-circle"></i> Filter by the type of business of the applicator.
            </small>
          </span>
          <div class="filter-form-options">
            <label v-for="(category, key) in businessTypeOptions" class="filter-form-checkbox" :key="`business-type-${key}`">
              <input type="checkbox" v-model="appliedFilters.businessTypes" :value="category.label" />
              <span class="checkbox-input"></span>
              <span>{{ category.label }}</span>
            </label>
          </div>
        </div>

        <div v-if="workAcceptedOptions.length" class="filter-form-field column">
          <span class="filter-form-field-label">
            <strong>Work Accepted</strong>
            <small>
              <i class="fa fa-info-circle"></i> Filter by the types of work the applicator accepts.
            </small>
          </span>
          <div class="filter-form-options">
            <label v-for="(category, key) in workAcceptedOptions" class="filter-form-checkbox" :key="`work-accepted-${key}`">
              <input type="checkbox" v-model="appliedFilters.workAccepted" :value="category.label" />
              <span class="checkbox-input"></span>
              <span>{{ category.label }}</span>
            </label>
          </div>
        </div>

        <div class="filter-form-field column">
          <span class="filter-form-field-label">
            <strong>Production Capability</strong>
            <small>
              <i class="fa fa-info-circle"></i> Filter by the production capability the applicator has.
            </small>
          </span>
          <div class="filter-form-options">
            <label v-for="(category, key) in certificationOptions" class="filter-form-checkbox" :key="`certification-${key}`">
              <input type="checkbox" v-model="appliedFilters.certifications" :value="category.id" />
              <span class="checkbox-input"></span>
              <span>{{ category.label }}</span>
            </label>
          </div>
        </div>

        <div class="filter-form-field column">
          <span class="filter-form-field-label">
            <strong>Search Radius</strong>
          </span>
          <div class="filter-form-options">
            <small>
              <i class="fa fa-info-circle"></i> Search radius in Miles
            </small>
            <input type="text" name="radius" v-model="appliedFilters.radius" id="radius" class="form-control" />
          </div>
        </div>

        <!-- <div class="filter-form-field column">
          <span class="filter-form-field-label">
            <strong>Customer Rating</strong>
            <small>
              <i class="fa fa-info-circle"></i> Filter by the average customer rating of the applicator.
            </small>
          </span>
          <div class="filter-form-options" id="filter-ratings">
            <label v-for="i of 5" class="filter-form-checkbox" :key="`rating-${i}`">
              <input type="checkbox" v-model="appliedFilters.rating" :value="i" />
              <span class="checkbox-input"></span>
              <span>
                <i v-for="j of 5" :class="`fa ${j <= i ? 'fa-star' : 'fa-star-o'}`"></i>
              </span>
            </label>
          </div>
        </div> -->

      </div>

      <div id="applicator-map-filter-form-footer">
        <button v-if="!applyFiltersAutomatically" :disabled="$root.loadingApplicators" type="submit" class="btn btn-alt-outline">Apply Filters</button>
        <button :disabled="$root.loadingApplicators" type="button" id="applicator-map-filter-form-reset" @click="ResetAllFilters">Reset all filters</button>
      </div>

    </div>
  </form>
</template>

<style lang="scss">
#applicator-map-filter {
  top: calc(var(--desktop-header-size) + var(--sidebar-padding));
  display: flex;
  flex: 1;

  @media screen and (max-width: 1024px) {
    top: calc(var(--mobile-header-size) + var(--sidebar-padding));
  }

  &-toggle-desktop {
    top: calc(var(--desktop-header-size) + var(--sidebar-padding));
    border-bottom-right-radius: var(--applicator-border-radius);
    border-top-right-radius: var(--applicator-border-radius);
    border: 1px solid #DBDBDB;
    background-color: #F9FAFC;
    justify-content: center;
    align-items: center;
    border-left: none;
    padding: 0 12px;
    position: sticky;
    display: none;
    height: 40px;
    width: auto;
    z-index: 5;
    left: 0;
    margin-left: -30px;

    @media screen and (max-width: 1500px) {
      display: flex;
    }

    @media screen and (max-width: 1024px) {
      display: none;
    }

    > i {
      margin-right: 8px;
    }

  }

  &-count {
    background-color: #3E6B85;
    padding: 5px 8px 6px 8px;
    border-radius: 4px;
    margin-left: 6px;
    font-weight: 600;
    font-size: 10px;
    line-height: 1;
    color: white;
  }

  &-form {
    flex-direction: column;
    padding: 0 !important;
    pointer-events: all;
    white-space: nowrap;
    display: flex;
    width: 100%;
    opacity: 1;

    @media screen and (max-width: 1024px) {
      width: 100%;
    }

    .filter-form-field {
      padding-right: var(--sidebar-padding);
      padding-bottom: 16px;
      flex-direction: row;
      display: flex;
      width: 100%;

      &:last-child {
        padding-bottom: 0;
      }

      &.column {
        flex-direction: column;
      }

      &-label {
        margin-right: calc(var(--sidebar-padding) * -1);
        align-items: flex-start;
        flex-direction: column;
        white-space: normal;
        display: flex;

        > small {
          margin-top: 4px;
          color: #828282;

          > i {
            margin-right: 2px;
          }

        }

      }

      select {
        font-weight: normal;
        padding: 0 8px;
        height: 40px;
        flex: 1;
      }

      + .filter-form-field {
        border-top: 2px solid #DBDBDB;
        padding-top: 16px;
      }

    }

    .filter-form-options {
      align-items: flex-start;
      flex-direction: column;
      margin-top: 8px;
      flex-wrap: wrap;
      display: flex;
      width: 100%;

      > .filter-form-checkbox {
        width: 50%;
      }

      &#filter-ratings {
        flex-direction: column-reverse;
        flex-wrap: nowrap;

        .fa {
          margin: 2px 2px 0 0;
          font-size: 18px;
          color: #D8D8D8;

          &.fa-star {
            color: #F69422;
          }

        }

      }

    }

    .filter-form-checkbox {
      align-items: center;
      flex-direction: row;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      height: 32px;
      margin: 0;

      .checkbox-input {
        transition: background-color 200ms ease-in-out, border-color 200ms ease-in-out;
        background-color: transparent;
        border: 2px solid #CCC;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        margin-right: 8px;
        cursor: inherit;
        display: flex;
        height: 16px;
        width: 16px;

        &::before {
          content: "✓";
          transition: opacity 200ms ease-in-out;
          font-size: 14px;
          color: white;
          opacity: 0;
        }

      }

      > input {
        visibility: hidden;
        display: none;

        &:checked + .checkbox-input {
          background-color: #3E6B85;
          border-color: #3E6B85;

          &::before {
            opacity: 1;
          }

        }

      }

      &:hover,
      &:focus-within {

        .checkbox-input {
          border-color: #3E6B85;
        }

      }

    }

    &-reset {
      background-color: transparent;
      text-decoration: underline;
      justify-content: center;
      align-items: center;
      display: flex;
      color: #3E6B85;
      height: 42px;
      border: none;
      padding: 0;

      &:hover,
      &:focus {
        text-decoration: underline;
      }

    }

    &-header {
      border-bottom: 2px solid #DBDBDB;
      padding-bottom: 16px;
      margin-bottom: 16px;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
      display: flex;

      @media screen and (max-width: 1024px) {
        margin-top: calc(var(--sidebar-padding) * -1);
        top: calc(var(--sidebar-padding) * -1);
        background-color: #F9FAFC;
        padding-top: 16px;
        position: sticky;
      }

      > h3 {
        margin: 0;
        flex: 1;
      }

      > button {
        background-color: transparent;
        border: none !important;
        width: 40px !important;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        color: #AAAAAA;
        line-height: 1;
        display: none;

        &#applicator-map-filter-close-desktop {
          display: none;

          @media screen and (max-width: 1500px) {
            display: flex;
          }

          @media screen and (max-width: 1024px) {
            display: none;
          }

        }

        &#applicator-map-filter-close-mobile {
          display: none;

          @media screen and (max-width: 1024px) {
            display: flex;
          }

        }

      }

    }

    &-content {
      flex-direction: column;
      max-height: none;
      overflow-y: auto;
      display: flex;
      width: 100%;
      flex: 1;

      @media screen and (max-width: 1024px) {
        max-height: 100%;
      }

    }

    &-footer {
      bottom: calc(var(--sidebar-padding) * -1);
      padding: var(--sidebar-padding) 0 0;
      background-color: #F9FAFC;
      flex-direction: column;
      position: sticky;
      display: flex;

      @media screen and (max-width: 1500px) {
        margin: 0 calc(var(--sidebar-padding) * -1) calc(var(--sidebar-padding) * -1);
        padding: var(--sidebar-padding) var(--sidebar-padding) 16px;
      }

      @media screen and (max-width: 1024px) {
        margin: var(--sidebar-padding) calc(var(--sidebar-padding) * -1) calc(var(--sidebar-padding) * -1);
        padding: 16px var(--sidebar-padding);
        background-color: #3E6B85;
        flex-direction: row;

        > button {
          color: white;
          flex: 1;

          &.btn {
            border-color: white;
          }

        }

      }

    }

  }

}
</style>

<script>

export default {
  name: "applicator-map-filters",

  data: () => {
    return {

      map: undefined,
      applyFiltersAutomatically: false,

      isVisible: false,
      distributorOptions: [
        {
          id: "cerakote_distributor",
          label: "Distributors"
        },
      ],
      businessTypeOptions: [],
      workAcceptedOptions: [],
      certificationOptions: [
        {
          id: "cerakote_robotics",
          label: "Cerakote Robotics Facility"
        },
        {
          id: "cerakote_high_volume",
          label: "High Volume Applicator"
        },
        {
          id: "cerakote_laser_certified",
          label: "Laser Imaging Certified"
        }
      ],

      appliedFilters: {
        businessTypes: [],
        workAccepted: [],
        certifications: [],
        distributors: [],
        rating: [],
        radius: '',
      },

    }
  },

  watch: {

    appliedFilters: {
      deep: true,
      handler() {
        if(this.applyFiltersAutomatically) {
          this.ApplyFilters();
        }
      }
    }

  },

  computed: {

    totalAppliedFilters() {

      let total = 0;

      total += this.map?.filters?.businessTypes?.length || 0;
      total += this.map?.filters?.workAccepted?.length || 0;
      total += this.map?.filters?.certifications?.length || 0;
      total += this.map?.filters?.distributors?.length || 0;
      total += this.map?.filters?.rating?.length || 0;

      return Number(total);

    }

  },

  async mounted() {

    this.map = this.$root.$refs['applicator-map'];

    await this.GetBusinessTypes();
    await this.GetWorkAcceptedCategories();

  },

  methods: {

    async GetBusinessTypes() {

      let { data } = await axios.get('api/proxify/user-categories?domain=cerakote&onlyBusinessTypes=true');

      this.businessTypeOptions = data;
      this.businessTypeOptions.sort((a, b) => (a.label > b.label) ? 1 : -1);

    },

    async GetWorkAcceptedCategories() {

      let { data } = await axios.get('api/proxify/work-accepted?domain=cerakote');

      this.workAcceptedOptions = data;
      this.workAcceptedOptions.sort((a, b) => (a.label > b.label) ? 1 : -1);

    },

    ResetAllFilters() {

      this.appliedFilters.certifications = [];
      this.appliedFilters.distributors = [];
      this.appliedFilters.businessTypes = [];
      this.appliedFilters.workAccepted = [];
      this.appliedFilters.rating = [];
      this.appliedFilters.radius = '';

      this.ApplyFilters();

    },

    ApplyFilters() {

      this.map.MapUpdated(this.appliedFilters);
      this.isVisible = false;

      this.$root.filtersVisibleOnDesktop = false;
      this.$root.filtersVisibleOnMobile = false;
      this.$root.showFooter = true;

    },

    ToggleVisibility(isVisible = !this.isVisible) {

      this.isVisible = isVisible;

    }

  }
}
</script>
